import React from 'react';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in" data-id="element-171">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" data-id="element-172">
        <div className="p-4 border-b border-orange-100 flex justify-between items-center bg-orange-50" data-id="element-173">
          <h3 className="text-xl font-serif font-bold text-orange-900" data-id="element-174">
            {title}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-orange-200 rounded-full transition-colors text-orange-700" data-id="element-175">
            <XIcon className="w-6 h-6" data-id="element-176" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-gray-700 leading-relaxed space-y-4" data-id="element-177">
          {content}
        </div>
      </div>
    </div>;
}